import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ isMobile: boolean }>`
  ${({ theme, isMobile }) => css`
    box-shadow: ${theme.elevation.ton8};
    padding: ${theme.spacing.km6};
    background-color: ${theme.color.background.neutral.default};
    display: flex;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    z-index: 20;
    justify-content: space-between;
    width: -webkit-fill-available;
    align-items: center;

    ${isMobile &&
    css`
      flex-direction: column;
      gap: ${theme.spacing.km6};
      align-items: flex-start;
    `}
  `}
`;
